import React from 'react'
import { apiPut, apiDelete } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { isEmpty } from 'lodash'
import useToastContext from 'hooks/useToastContext'
import { AiFillEdit, AiFillDelete, AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import helper from '../../utils/helpers'
import { NavLink } from 'react-router-dom'

const UnionTable = ({
  districts,
  getAllUnions,
  handelEdit,
  user,
  page,
  sort,
  setSort,
  manager,
  upazila
}) => {
  const { t } = useTranslation()
  const notification = useToastContext()

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.unionStatusChange}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getAllUnions()
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative rounded-lg border'>
        <table className='w-full   text-sm text-left text-[#4d4c4c]  dark:text-gray-400 '>
          <thead className='text-sm text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-2'>
                #
              </th>
              <th
                scope='col'
                className='py-3 px-2 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'name' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'name',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'name',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex '>
                  <span>{t('O_NAME')} </span>
                  <span>
                    {sort.sort_key === 'name' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'name' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>  
              <th
                scope='col'
                className='py-3 px-2 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'bnName' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'bnName',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'bnName',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex '>
                  <span>{t('O_BN_NAME')} </span>
                  <span>
                    {sort.sort_key === 'bnName' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'bnName' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>  
              {(manager?.add || user?.role === 'admin') && (
                <th scope='col' className='py-3 px-2 text-center'>
                  {t('O_STATUS')}
                </th>
              )}
              <th scope='col' className='py-3 px-2 text-center'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {districts &&
                districts?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>
                    {item?.name}
                  </td>
                  <td className='py-2 px-2 border-r'>
                    {item?.bnName}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          disabled={upazila?.status=== 'inactive'}
                          onChange={e =>
                            helper.alertFunction(
                              `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                              } this union?`,
                              item,
                              handelStatusChange
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className='py-2 px-2 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                      {(manager?.add ||
                          user?.role==='admin') && (
                            <li
                              onClick={() => handelEdit(item)}
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                            >
                              <span
                                title={t('O_EDIT')}
                                className='hover:text-blue-700 transition duration-150 ease-in-out'
                                data-bs-toggle='tooltip'
                              >
                                <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                              </span>
                            </li>
                          )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(districts) ? (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-2 px-2 border-r' colSpan={8}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default UnionTable
